import {AbstractControl} from '@angular/forms';

export class UploadFormValidator {
  static dateRange(AC: AbstractControl) {
    if (!AC.value) {
      return null;
    } else {
      const time = (new Date()).getTime();
      if (AC.value.getTime() > time || AC.value.getFullYear() < 1970) {
        return {'daterange': true};
      }
    }
    return null;
  }
}
